import React, { useEffect, useState } from "react";
import List from "./List";

const TocList = ({ book, setContent }) => {
  const [contentKey, setContentKey] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedSection, setSelectedSection] = useState("");
  useEffect(() => {
    if (book.value) {
      setSelectedIndex(0);
      setContentKey(book.value[0]?.contentKey);
      if (book.value[0].section === "") {
        setSelectedSection("Default")
      } else {
        setSelectedSection(book.value[0]?.section)

      }
    }
  }, [book]);

  const assignContentKey = (value, index, section) => {

    setContentKey(value);
    setSelectedIndex(index);
    setSelectedSection(section)
  };

  return (
    <>
      {book && book.value && (
        <>
          <div className="d-flex float-left mt-3 pl-2 toc-tabs">
            <div className="flex-fill">
              <ul className="book-type">
                {book.value
                  .sort((a, b) => a.order - b.order)
                  .map((item, index) => (
                    <li
                      key={"book_type_" + index}
                      className={"book-type-item"}
                      id={item.contentKey}
                    >
                      <a
                        id={item.contentKey}
                        className={
                          index == selectedIndex
                            ? "type-tab active"
                            : "type-tab"
                        }
                        onClick={() => assignContentKey(item.contentKey, index, item.section)}
                      >
                        {item.section}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div className="inline-block float-left w-full toc-header">
            {book.label}
          </div>
          {contentKey !== "" && (
            <List contentKey={contentKey} setContent={setContent} book={book} selectedSection={selectedSection} />
          )}
        </>
      )}
    </>
  );
};

export default TocList;
